/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 02.09.2016.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import _get from 'lodash/get';

import {GetPackages} from '../actions/collection/actions-collection';
import {parseAppUrl} from '../utils';

import DocumentTitle from 'react-document-title';
import Translate from '../components/Translate';
import ShowcaseCollection from '../containers/ShowcaseCollection';

class IndexRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentWillMount() {
    this.props.GetPackages();
  }

  render() {
    if (_get(Config, 'show_all_categories_in_home', false)) {
      let categories = _get(this.props, 'categories', []);

      return <DocumentTitle title={Translate.translator('page.home')}>
        <div>
          {categories.map((category, index) => {
            var url = parseAppUrl('ui://showcase?categories='+ category.extid +'&views=vod,live', this.props.categories).replace('/showcase/', '');

            return (<ShowcaseCollection id={'section_' + index + '_' + url} key={'section_' + category.extid} url={url} isPreview={true} startLimit={18} />);
          })}
        </div>
      </DocumentTitle>;

    } else {
      let sections = _get(Config, 'sections', []);

      return <DocumentTitle title={Translate.translator('page.home')}>
        <div>
          {sections.map((section, index) => {
            var url = parseAppUrl(section.app_url, this.props.categories).replace('/showcase/', '');

            return (<ShowcaseCollection id={'section_' + index + '_' + url} key={'section_' + section.app_url} url={url} isPreview={true} startLimit={18} />);
          })}
        </div>
      </DocumentTitle>;
    }
  }
}

const mapStateToProps = ({common: {categories}}) => {

  return {
    categories
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({GetPackages}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexRoute);



// WEBPACK FOOTER //
// ./src/routes/index-route.js